export default __webpack_public_path__ + "static/media/Kerim's Blessing.bc23570e.jpg";